export default "__VITE_ASSET__uHoFuvU1__"